import { withInstall } from '../../utils/install';
import Carousel from './index.vue';

export const IvueCarousel = withInstall(Carousel);
export default IvueCarousel;

export * from './index.vue';
